import React, { useState } from "react";
import { X } from "react-feather";
import SaveButton from "../../../CommonComponents/SaveButton/SaveButton";
import CustomDragAndDrop from "../../../CommonComponents/CustomDragAndDrop/CustomDragAndDrop";

import "./stylesCategoriesPopup.css";
import { Image, message } from "antd";

function CategoriesPopup({ isVisible, onClosePressed, getEventCodesList }) {
  const [messageApi, contextHolder] = message.useMessage();

  const [comment, setComment] = useState("");
  const [iconBase64, setIconBase64] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const maxChars = 50;

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!comment.trim()) {
      messageApi.error("Please enter a category name");

      return;
    }

    setIsSubmitting(true);
    try {
      await getEventCodesList({
        icon: iconBase64,
        name: comment,
        etype: "category",
      });
      onClosePressed();
    } catch (error) {
      console.error("Error submitting category:", error);
      alert("Failed to submit category. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleFileUpload = (base64) => {
    setIconBase64(base64);
  };

  const handleClose = () => {
    setComment("");
    setIconBase64("");
    onClosePressed(false);
  };

  const onRemove = () => {
    setIconBase64("");
  };

  if (!isVisible) return null;

  return (
    <div className="location-restrictions-popup">
      {contextHolder}
      <div className="location-restrictions-panel">
        <div className="location-restrictions-panel-header">
          <h2>New Category</h2>
          <button className="close-button" onClick={handleClose}>
            <X className="close-icon" />
          </button>
        </div>
        <form onSubmit={handleSubmit}>
          <CustomDragAndDrop
            onFileUpload={handleFileUpload}
            onRemove={onRemove}
          />
          {iconBase64 && (
            <div className="drag-drop-image-preview">
              <Image
                src={iconBase64}
                alt="Game Icon Preview"
                className="preview-img"
              />
            </div>
          )}
          <div className="event-code-input">
            <label htmlFor="eventCode">Name</label>
            <textarea
              id="eventCode"
              value={comment}
              placeholder="Category Name"
              onChange={(e) => setComment(e.target.value)}
              rows="1"
              required
            />
            <div className="comment-counter">
              {comment.length}/{maxChars}
            </div>
          </div>
          <SaveButton
            isApiRunning={isSubmitting}
            buttonText="Add Category"
            cancelButton={true}
            cancelButtonText="No"
            callbackFunction={handleSubmit}
            callbackFunctionCancel={handleClose}
          />
        </form>
      </div>
    </div>
  );
}

export default CategoriesPopup;
